<template>
  <div class="margin-70">
    <BigTitle :bigtitle="bigtitle"></BigTitle>
    <div class="operaBox padding-sm margin-top-sm">
      <div class="operation flex align-center padding-tb-xs" v-for="(item,index) in overviewList" :key="index">
        <div class="margin-left-sm margin-right-sm operateImg"><img class="operateIcon" :src="item.img"/></div>
        <div class="flex flex-direction">
          <p class="text-xsss">{{item.text}}</p>
          <!-- <dv-digital-flop class="digitalFlop text-xxl-xl DS-font" :config="item.number"/> -->
          <div class="digitalFlop text-xxl-xl DS-font" :style="{'color':item.number.style.fill}">{{item.number.content}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BigTitle from '../bigTitle';
// 综合态势--动态渲染图片
import overview00 from '@/assets/images/index/charge_station.png';
import overview0 from '@/assets/images/index/overview0.png';
import overview1 from '@/assets/images/index/overview1.png';
import overview2 from '@/assets/images/index/overview2.png';
import overview3 from '@/assets/images/index/overview3.png';
import overview4 from '@/assets/images/index/overview4.png';

import { dataInterface } from '@/api/dataInterfaceApi';
import {formatNumber} from '@/utils/index'
import {mapMutations} from "vuex";

export default {
  data () {
    return {
      options: {},
      bigtitle:{
        CHN:'综合态势',
        ENG:'Overview'
      },
      overviewList:[
        {
            text:'充电站数量(座)',
            number:{content:'0',textAlign:'left',style:{fill:'#36FBFB',fontFamily:'DS-Digital-Bold',fontSize:50}},
            img:overview00
        },
        {
          text:'换电站数量(座)',
          number:{content:'0',textAlign:'left',style:{fill:'#36FBFB',fontFamily:'DS-Digital-Bold',fontSize:50}},
          img:overview0
        },
        {
          text:'换电车辆数(辆)',
          number:{content:'0',textAlign:'left',style:{fill:'#43FFB9',fontFamily:'DS-Digital-Bold',fontSize:50}},
          img:overview1
        },
        {
          text:'充电电量(kWh)',
          number:{content:'0',textAlign:'left',style:{fill:'#FFFFFF',fontFamily:'DS-Digital-Bold',fontSize:50}},
          img:overview2
        },
        {
          text:'换电站里程(km)',
          number:{content:'0',textAlign:'left',style:{fill:'#179DFF',fontFamily:'DS-Digital-Bold',fontSize:50}},
          img:overview3
        },
        {
          text:'换电次数',
          number:{content:'0',textAlign:'left',style:{fill:'#36FBFB',fontFamily:'DS-Digital-Bold',fontSize:50}},
          img:overview4
        }
      ]
    };
  },
  components: {
    BigTitle
  },
  props: {
    // operList: {
    //   type: Object,
    //   default: () => ({})
    // },
  },
  watch: {
    
  },
  mounted () {
    this.$nextTick(() =>{
      this.$EventBus.$on('change',(value) =>{
        console.log(value,'hcanegsdhisdusuhs')
        this.getData({province:value})
      })
    });
  },
  methods: {
      ...mapMutations(['SETtotal_station_num', 'SETStationAccessNum']),
    getData(data){
      // this.quanguoChongdianzhanshuliang(data);
      // this.quanguoleijichongdiandianliang(data);
      // this.quanguoHuandianzhanshuliang(data);
      // this.quanguoCheliangshulicheng(data);
      // this.quanguoHuandiancis(data);
      console.log(data,'可口可乐')
      const { query } = this.$route
      if(query.token) localStorage.setItem('uid',query.token )
      let params = {
        "enCode":"hdz-zhts",
        "@province":data.province||data.city||data.district || '000000',
        '@uid': localStorage.getItem('uid') || '000000'
      }
      dataInterface
        .dataFaceApiXZ(params)
        .then((res) => {
          console.log(res,'可口可乐返回的数据')
          if(!res) return;
          res=res[0];
          this.overviewList[0].number.content = 0
          this.overviewList[1].number.content = res.hdz || 0
          this.overviewList[2].number.content = res.ljhdcl || 0
          this.overviewList[3].number.content = res.ljcddl || 0
          this.overviewList[4].number.content = res.ljhdlc || 0
          this.overviewList[5].number.content = res.ljhdcs || 0
        })
        .catch((err) => {
          console.log(err);
        });
    },
      /**
       * 获取充电站数量  接口待调整
       * @param data 省市区坐标
       */
    quanguoChongdianzhanshuliang(data={}){
      let _this = this;

      let params = {};
			if(data){
				//TiDB-省市区-充电站数量
				params = {
					"enCode":"TiDB-xiazuan-stationNum",
					"@station_type":"充电桩",
          "@ADCODE":data.province||data.city||data.district
				}
			}else {
          //全国-充电站数量
          params = {
              "enCode":"TiDB-xiazuan-stationNum",
              "@station_type":"充电桩",
              "@ADCODE":"000000"
          }

			}
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
          res=res[0];
          _this.$set(this.overviewList,0,{
              text:'充电站数量(座)',
              number:{content:res.total_station_num.toString(),textAlign:'left',style:{fill:'#36FBFB',fontFamily:'DS-Digital-Bold',fontSize:50}},
              img:overview00
          })
          this.SETtotal_station_num(res.total_station_num.toString())
        })
        .catch((err) => {
          console.log(err);
        });
    },
    quanguoHuandianzhanshuliang(data={}){
      let _this = this;

      let params = {};
			if(data){
				//TiDB-省市区-换电站数量
				params = {
					"enCode":"TiDB-shengshiqu-huandianzhanshuliang",
    			"@province":data.province||data.city||data.district
				}
			}else {
				params = {
					"enCode":"TiDB-quanguo-huandianzhanshuliang"//TiDB-全国-换电站数量
				}
			}
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
          res=res[0];
          _this.$set(this.overviewList,1,{
              text:'换电站数量(座)',
              number:{content:res.stationAccessNum.toString(),textAlign:'left',style:{fill:'#36FBFB',fontFamily:'DS-Digital-Bold',fontSize:50}},
              img:overview0
          })
            this.SETStationAccessNum(res.stationAccessNum.toString())
        })
        .catch((err) => {
          console.log(err);
        });
    },
    quanguoCheliangshulicheng(data={}){
      let _this = this;

      let params = {};
			if(data){
				params = {
					"enCode":"TiDB-shengshiqu-cheliangshulicheng",//TiDB-省市区-车辆数里程
    			"@province":data.province||data.city||data.district
				}
			}else {
				params = {
					"enCode":"TiDB-quanguo-cheliangshulicheng"//TiDB-全国-车辆数里程
				}
			}
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
        res=res[0];

          _this.$set(this.overviewList,2,{
          text:'累计换电车辆数(辆)',
          number:{content:formatNumber(res.vehicleNum.toString()),textAlign:'left',style:{fill:'#43FFB9',fontFamily:'DS-Digital-Bold',fontSize:50}},
          img:overview1
        })
  
      _this.$set(this.overviewList,4,{
          text:'累计换电里程(km)',
          number:{content:formatNumber(res.batteryMileage.toString()),textAlign:'left',style:{fill:'#179DFF',fontFamily:'DS-Digital-Bold',fontSize:50}},
          img:overview3
        })
        })
        .catch((err) => {
          console.log(err);
        });
    },
    quanguoHuandiancis(data={}){
      let _this = this;

      let params = {};
			if(data){
				params = {
					"enCode":"TiDB-shengshiqu-huandiancishu",//TiDB-省市区-换电次数
    			"@province":data.province||data.city||data.district
				}
			}else {
				params = {
					"enCode":"TIDB-quanguo-huandiancishu"//TiDB-全国-换电次数
				}
			}
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
          console.log("累计换电次数",res)
          res=res[0];
        _this.$set(this.overviewList,5,{
          text:'累计换电次数',
          number:{content:formatNumber(res.xchangePowerNum.toString()),textAlign:'left',style:{fill:'#36FBFB',fontFamily:'DS-Digital-Bold',fontSize:50}},
          img:overview4
        })
		
        })
        .catch((err) => {
          console.log(err);
        });
    },
    quanguoleijichongdiandianliang(data={}){
      let _this = this;

      let params = {};
			if(data){
				//TiDB-省市区-充电电量
				params = {
					"enCode":"TiDB-shengshiqu-chongdiandianliang",
    			"@province":data.province||data.city||data.district
				}
			}else {
				params = {
					"enCode":"TiDB-quanguo-chongdiandianliang"//TiDB-全国-充电电量
				}
			}
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
          res=res[0];
        _this.$set(this.overviewList,3,{
            text:'累计充电电量(kWh)',
            number:{content:formatNumber(res.totalelect),textAlign:'left',style:{fill:'#FFFFFF',fontFamily:'DS-Digital-Bold',fontSize:50}},
            img:overview2
        })
		
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/overview.scss';
.operaBox{
  background : rgba(19, 29, 35,.6);
}
</style>